import { apiCall } from "../../services/api-service";

export const geVehicleListApi = (params) =>
  apiCall("get", `vehicle?${params}`);

export const geVehicleAssignmentListApi = (params) =>
  apiCall("get", `vehicle_assignment?${params}`);

export const geKMHistoryListApi = (params) =>
  apiCall("get", `km_history?${params}`);

export const geExpenseHistoryListApi = (params) =>
  apiCall("get", `expense_history?${params}`);

export const geFuelHistoryListApi = (params) =>
  apiCall("get", `fuel_history?${params}`);
